<div class="container">
  <div class="hidden md:block md:mb-6">
    <app-breadcrumbs [items]="breadcrumbs"></app-breadcrumbs>
  </div>
  <div class="md:hidden">
    <app-mobile-subheader [title]="'Сервисы'"></app-mobile-subheader>
  </div>
  <div class="section-header text-center">
    <h1 class="mobile-h1-title md:font-bold md:text-4xl">
      <div class="mb-1 md:hidden">
        <img src="../../../assets/images/svg_new/service/keys2.svg" alt="#" class="w-10 my-auto" />
      </div>
      Сервисы
    </h1>
  </div>
  @for (entry of data | keyvalue: unsorted; track $index) {
    <section class="mb-4 md:mb-5">
      <h2 class="mb-4 text-xl md:mb-5 md:text-2xl">{{ entry.value.title }}</h2>
      <div class="services-row">
        @for (item of entry.value.items; track $index) {
          <div class="service-item">
            <h3 class="service-item__title">{{ item.title }}</h3>
            <div class="service-item__caption">{{ item.caption }}</div>
            <div class="service-item__bottom">
              <a class="service-item__more" [href]="item.slug">Подробнее</a>
              <img class="service-item__icon" src="../../../assets/images/svg_new/service/{{ item.iconName }}.svg" alt="#" />
            </div>
          </div>
        }
      </div>
    </section>
  }
</div>
<app-page-callback-form [title]="'Консультация бесплатно'" [caption]="'Оставьте заявку на консультацию'"></app-page-callback-form>
<app-page-offers></app-page-offers>
